// extracted by mini-css-extract-plugin
module.exports = {"height":"HeroSection_height__F5YSG","heroBanner":"HeroSection_heroBanner___BsX3","overlay":"HeroSection_overlay__HAADM","heroText":"HeroSection_heroText__gKLPx"};